import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface DocumentUpload {
  id?: string;
  name: string;
  url?: string;
  docTypeId: string | undefined;
  referenceId?: string | undefined;
}

interface DocumentUploadState {
  documentsUpload: DocumentUpload[];
  setDocumentsUpload: (newDocuments: DocumentUpload[] | undefined) => void;
}

export const useDocumentUploadStore = create<DocumentUploadState>()(
  devtools(
    (set) => ({
      documentsUpload: [],
      setDocumentsUpload: (newDocuments) =>
        set(() => ({
          documentsUpload: newDocuments ? [...newDocuments] : [],
        })),
    }),
    { name: "DocumentsUploadedStore" }
  )
);
